import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=10fdbb61&scoped=true"
import script from "./NewMessage.vue?vue&type=script&lang=ts"
export * from "./NewMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fdbb61",
  null
  
)

export default component.exports